/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SellerProductReferenceFromJSON, SellerProductReferenceToJSON, } from './SellerProductReference';
/**
 * Check if a given object implements the SummaryProductRejected interface.
 */
export function instanceOfSummaryProductRejected(value) {
    let isInstance = true;
    isInstance = isInstance && "errorCode" in value;
    isInstance = isInstance && "sellerProductReference" in value;
    return isInstance;
}
export function SummaryProductRejectedFromJSON(json) {
    return SummaryProductRejectedFromJSONTyped(json, false);
}
export function SummaryProductRejectedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorCode': json['error_code'],
        'errorDescription': !exists(json, 'error_description') ? undefined : json['error_description'],
        'sellerProductReference': SellerProductReferenceFromJSON(json['seller_product_reference']),
    };
}
export function SummaryProductRejectedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error_code': value.errorCode,
        'error_description': value.errorDescription,
        'seller_product_reference': SellerProductReferenceToJSON(value.sellerProductReference),
    };
}
